import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _acceptApprovalRequestRequest = {};
var _acceptApprovalRequestResponse = { approvalRequest: '_approvalRequest' };
var _approvalRequest = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _countApprovalRequestsRequest = {};
var _countApprovalRequestsResponse = {};
var _createApprovalRequestRequest = { approvalRequest: '_approvalRequest' };
var _createApprovalRequestResponse = { approvalRequest: '_approvalRequest' };
var _getApprovalRequestRequest = {};
var _getApprovalRequestResponse = { approvalRequest: '_approvalRequest' };
var _queryApprovalRequestsRequest = {};
var _queryApprovalRequestsResponse = { approvalRequests: '_approvalRequest' };
var _rejectApprovalRequestRequest = {};
var _rejectApprovalRequestResponse = { approvalRequest: '_approvalRequest' };
var _updateApprovalRequestRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    approvalRequest: '_approvalRequest',
};
var _updateApprovalRequestResponse = { approvalRequest: '_approvalRequest' };
function resolveWixAgentmakerApprovalsV1ApprovalsUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_api/agent-maker-approvals',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/agent-maker-approvals',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/agent-maker-approvals',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/agent-maker-approvals',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates an ApprovalRequest. */
export function createApprovalRequest(payload) {
    var _a = serializer(_createApprovalRequestRequest, { _approvalRequest: _approvalRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __createApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'POST',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.CreateApprovalRequest',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createApprovalRequest.fromReq = fromReq;
    __createApprovalRequest.__isAmbassador = true;
    return __createApprovalRequest;
}
/** Retrieves an ApprovalRequest. */
export function getApprovalRequest(payload) {
    var _a = serializer(_getApprovalRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __getApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'GET',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.GetApprovalRequest',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/{approvalRequestId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getApprovalRequest.fromReq = fromReq;
    __getApprovalRequest.__isAmbassador = true;
    return __getApprovalRequest;
}
/** Updates an ApprovalRequest. */
export function updateApprovalRequest(payload) {
    var _a = serializer(_updateApprovalRequestRequest, { _approvalRequest: _approvalRequest }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __updateApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'PATCH',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.UpdateApprovalRequest',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/{approvalRequest.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateApprovalRequest.fromReq = fromReq;
    __updateApprovalRequest.__isAmbassador = true;
    return __updateApprovalRequest;
}
/** Retrieves a list of ApprovalRequests, given the provided [paging, filtering, and sorting] */
export function queryApprovalRequests(payload) {
    var _a = serializer(_queryApprovalRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryApprovalRequestsResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __queryApprovalRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'POST',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.QueryApprovalRequests',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryApprovalRequests.fromReq = fromReq;
    __queryApprovalRequests.__isAmbassador = true;
    return __queryApprovalRequests;
}
/** Retrieves the count of ApprovalRequests, given the provided filter. */
export function countApprovalRequests(payload) {
    var _a = serializer(_countApprovalRequestsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countApprovalRequestsResponse, {}).fromJSON;
    function __countApprovalRequests(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'POST',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.CountApprovalRequests',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countApprovalRequests.fromReq = fromReq;
    __countApprovalRequests.__isAmbassador = true;
    return __countApprovalRequests;
}
/** Accepts a pending ApprovalRequest. */
export function acceptApprovalRequest(payload) {
    var _a = serializer(_acceptApprovalRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_acceptApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __acceptApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'POST',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.AcceptApprovalRequest',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/{approvalRequestId}/accept',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __acceptApprovalRequest.fromReq = fromReq;
    __acceptApprovalRequest.__isAmbassador = true;
    return __acceptApprovalRequest;
}
/** Rejects a pending ApprovalRequest. */
export function rejectApprovalRequest(payload) {
    var _a = serializer(_rejectApprovalRequestRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectApprovalRequestResponse, {
        _approvalRequest: _approvalRequest,
    }).fromJSON;
    function __rejectApprovalRequest(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.approvals.v1.approval_request',
            method: 'POST',
            methodFqn: 'wix.agentmaker.approvals.v1.Approvals.RejectApprovalRequest',
            url: resolveWixAgentmakerApprovalsV1ApprovalsUrl({
                protoPath: '/v1/approval-requests/{approvalRequestId}/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectApprovalRequest.fromReq = fromReq;
    __rejectApprovalRequest.__isAmbassador = true;
    return __rejectApprovalRequest;
}
//# sourceMappingURL=http.impl.js.map